import React, { Component } from 'react';
import GalleryImage from './GalleryImage/GalleryImage';
import {applicationModes} from '../constants';

let imageDescriptors = {
  default: {
    image1: {
      transformation: { aspect_ratio: '315:250', width: 'auto', crop: 'fill', gravity: 'faces', radius: 50, effect: 'saturation:50' },
      description: '<ul><li>Resize and crop the image to optimally fit the required height and width</li><li>Focus on automatically detected faces</li><li>Apply more saturation</li><li>Add rounded corners</li></ul>'
    },
    image2: {
      transformation: { dpr: 'auto', aspect_ratio: '355:247', width: 'auto', crop: 'fill', gravity: 'faces', effect: 'sharpen:200' },
      description: '<ul><li>Resize and crop the image to the relevant size</li><li>Focus on automatically detected faces</li><li>Sharpen the image</li></ul>'
    },
    image3: {
      transformation: { dpr: 'auto', aspect_ratio: '720:247', width: 'auto', crop: 'fill', gravity: 'faces', effect: 'sepia' },
      description: '<ul><li>Resize and crop the image to the relevant size</li><li>Focus on automatically detected faces</li><li>Apply a sepia effect</li></ul>'
    },
    image4: {
      transformation: { dpr: 'auto', aspect_ratio: '120:247', width: 'auto', crop: 'fill', gravity: 'auto' },
      description: '<p>Create a portrait image by cropping the image based on the auto-detected area of interest in the photo.</p>'
    },
    image5: {
      transformation: { dpr: 'auto', aspect_ratio: '595:247', width: 'auto', crop: 'fill', gravity: 'faces', effect: 'blue:100' },
      description: '<ul><li>Crop the image to a different aspect ratio, focusing on auto-detected faces</li><li>Increase the intensity of the blue channel</li></ul>'
    },
    image6: {
      transformation: { dpr: 'auto', aspect_ratio: '192:247', width: 'auto', crop: 'thumb', gravity: 'auto' },
      description: '<p>Create a thumbnail dynamically.</p><ul><li>Focus on the auto-detected area of interest</li><li>Crop and resize the image to the desired dimensions</li></ul>'
    },
    image7: {
      transformation: [{ aspect_ratio: '288:247', width: 'auto', crop: 'fill', gravity: 'faces' }, { overlay: 'cloudinary_icon', gravity: 'center', width: 0.6, flags: 'relative', color: 'white', effect: 'colorize', opacity: 50 }],
      description: '<p>Add a watermark on-the-fly.</p><ul><li>Overlay an existing image already uploaded to Cloudinary, in this case the Cloudinary logo</li><li>Set the overlay dimensions to 60% of the image size</li><li>Make it white and set its opacity to 50%</li>'
    }
  },
  ga: {
    image1: {
      transformation: { aspect_ratio: '315:250', width: 'auto', crop: 'fill', gravity: 'auto' },
      description: '<ul><li>Resize and crop the image to optimally fit the required height and width</li><li>Focus on automatically detected areas of interest</li></ul>'
    },
    image2: {
      transformation: { dpr: 'auto', aspect_ratio: '355:247', width: 'auto', crop: 'thumb', gravity: 'auto' },
      description: '<p>Create a thumbnail dynamically.</p><ul><li>Focus on the auto-detected area of interest</li><li>Crop and resize the image to the desired dimensions</li></ul>'
    },
    image3: {
      transformation: { dpr: 'auto', aspect_ratio: '720:247', width: 'auto', crop: 'fill', gravity: 'auto' },
      description: '<ul><li>Resize and crop the image to the relevant size</li><li>Focus on automatically detected areas of interest</li></ul>'
    },
    image4: {
      transformation: { dpr: 'auto', aspect_ratio: '120:247', width: 'auto', crop: 'fill', gravity: 'auto' },
      description: '<ul><li>Create a portrait image by cropping the image based on the auto-detected area of interest in the photo</li></ul>'
    },
    image5: {
      transformation: { dpr: 'auto', aspect_ratio: '595:247', width: 'auto', crop: 'fill', gravity: 'auto' },
      description: '<ul><li>Crop the image to a different aspect ratio, focusing on automatically detected areas of interest</li></ul>'
    },
    image6: {
      transformation: { dpr: 'auto', aspect_ratio: '192:247', width: 'auto', crop: 'thumb', gravity: 'auto' },
      description: '<p>Create a thumbnail dynamically.</p><ul><li>Focus on the auto-detected area of interest</li><li>Crop and resize the image to the desired dimensions</li></ul>'
    },
    image7: {
      transformation: [{ aspect_ratio: '288:247', width: 'auto', crop: 'fill', gravity: 'auto' }],
      description: '<ul><li>Resize and crop the image to optimally fit the required height and width</li><li>Focus on automatically detected areas of interest</li></ul>'
    }
  }
};

export default class GalleryLarge extends Component {
  render() {
    let desc = imageDescriptors[this.props.applicationMode] || imageDescriptors[applicationModes.DEFAULT];

    return (
      <div style={{ position: 'relative' }} className="gallery-large">
        <GalleryImage {...this.props} className="primary" style={{ width: '31.50vw', height: '25vw' }} transformation={desc.image1.transformation} format="jpg" id="large1">
          <div dangerouslySetInnerHTML={{ __html: desc.image1.description }} />
        </GalleryImage>
        <GalleryImage {...this.props} transformation={desc.image2.transformation} format="jpg" style={{ width: '18.50%', top: 0, bottom: '50%', left: '31.5%', zIndex: 2 }}>
          <div dangerouslySetInnerHTML={{ __html: desc.image2.description }} />
        </GalleryImage>
        <GalleryImage {...this.props} transformation={desc.image3.transformation} format="jpg" style={{ width: '37.50%', top: 0, bottom: '50%', left: '50%' }}>
          <div dangerouslySetInnerHTML={{ __html: desc.image3.description }} />
        </GalleryImage>
        <GalleryImage {...this.props} transformation={desc.image4.transformation} format="jpg" style={{ width: '12.50%', top: 0, bottom: 0, right: 0 }}>
          <div dangerouslySetInnerHTML={{ __html: desc.image4.description }} />
        </GalleryImage>
        <GalleryImage {...this.props} transformation={desc.image5.transformation} format="jpg" style={{ width: '31%', top: '50%', bottom: 0, left: '31.5%' }}>
          <div dangerouslySetInnerHTML={{ __html: desc.image5.description }} />
        </GalleryImage>
        <GalleryImage {...this.props} transformation={desc.image6.transformation} format="jpg" style={{ width: '10%', top: '50%', bottom: 0, left: '62.5%' }}>
          <div dangerouslySetInnerHTML={{ __html: desc.image6.description }} />
        </GalleryImage>
        <GalleryImage {...this.props} transformation={desc.image7.transformation} format="jpg" style={{ width: '15%', top: '50%', bottom: 0, left: '72.5%', dpr: 'auto' }}>
          <div dangerouslySetInnerHTML={{ __html: desc.image7.description }} />
        </GalleryImage>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/components/GalleryLarge.js
 **/